export const hasValue = (value: any): boolean => {
	return value !== undefined && value !== null && value !== ''
}
